var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createTimeText } from '../../utils/dateTime';
import { deepCamelize } from '../../utils/service';
var adaptWeeklyReportStudents = function (students) {
    return Object.entries(students).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        acc.push(__assign(__assign({}, deepCamelize(value)), { id: parseInt(key, 10) }));
        return acc;
    }, []);
};
var mapStuckStudent = function (student) { return ({
    id: student.id + "_" + student.card_id,
    originalId: student.id,
    studentName: student.name,
    cardName: student.task_name,
    startDate: new Date(student.started_date),
    timeSpent: createTimeText(student.spent),
    timeSpentAverage: student.average_completion_time,
    accuracy: student.right_answers + "/" + student.total_answers + " (" + student.accuracy + "%)",
    studentLink: student.student_link,
    cardLink: student.card_link,
}); };
var adaptWeeklyReportToClient = function (data) {
    return __assign(__assign({}, deepCamelize(data)), { students: adaptWeeklyReportStudents(data.students), timeTargetCompletion: data.time_target_completion, taskTargetCompletion: data.task_target_completion, stuckStudents: data.stuck_students.map(mapStuckStudent) });
};
export { adaptWeeklyReportToClient, adaptWeeklyReportStudents };
